import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT',
  GET: 'GET_PROJECT',
  CREATE: 'CREATE_PROJECT',
  EDIT: 'EDIT_PROJECT',
  DELETE: 'DELETE_PROJECT',
  REMOVE_IMAGE: 'REMOVE_IMAGE',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  EXPORT_REPORT: 'EXPORT_REPORT',
  EXPORT_SUMMARY_REPORT: 'EXPORT_SUMMARY_REPORT',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
  CREATE_BUILDING: 'CREATE_BUILDING',
  EDIT_BUILDING: 'EDIT_BUILDING',
  DELETE_BUILDING: 'DELETE_BUILDING',
};

export const searchProjectByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  const projectId = null;
  return searchProject(pageSize, page, sorted, filtered, isPublic, projectId);
};

export const searchProject = (pageSize, page, sorted, filtered, isPublic, extraParams = {}) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id).join(',')
        : null,
      is_public: isPublic,
      ...extraParams,
    },
  });
};

export const listAllProject = (page = 0, pageSize = 10, filtered = null, filterParams = {}) => {
  const sorted = [{ id: 'modified_date', desc: true }];
  const isPublic = null;
  return {
    type: ACTION.LIST,
    payload: searchProject(pageSize, page, sorted, filtered, isPublic, filterParams)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const getProject = projectId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_PROJECT}${projectId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const createProject = params => {
  const {
    name,
    image,
    address,
    building_type_id,
    is_mixed_use,
    owner,
    designer,
    issuer,
    car_park_area,
    roof_top_area,
    other_area_with_roof,
    height,
    building_cost,
    latitude,
    longitude,
    province_id,
    description,
    evaluation_purpose,
  } = params;

  const formData = new FormData();
  formData.set('name', name);
  if (image) formData.set('image', image);
  formData.set('address', address);
  formData.set('building_type_id', building_type_id);
  formData.set('is_mixed_use', is_mixed_use);
  formData.set('owner', owner);
  formData.set('designer', designer);
  formData.set('issuer', issuer);
  formData.set('car_parking_area', car_park_area);
  formData.set('roof_top_area', roof_top_area);
  formData.set('other_area_with_roof', other_area_with_roof);
  formData.set('height', height);
  formData.set('building_cost', building_cost);
  formData.set('latitude', latitude);
  formData.set('longitude', longitude);
  formData.set('province_id', province_id);
  formData.set('description', description || '');
  if (evaluation_purpose) formData.set('evaluation_purpose', evaluation_purpose);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

/** POST /api/project/{source_id}/create_followup/ — copy from source project (server-side). */
export const createProjectFollowup = (sourceProjectId, options = {}) => {
  const { evaluation_purpose } = options;
  const formData = new FormData();
  if (evaluation_purpose != null && String(evaluation_purpose).trim() !== '') {
    formData.set('evaluation_purpose', String(evaluation_purpose).trim());
  }

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT}${sourceProjectId}/create_followup/`,
      data: formData,
    }).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err)),
  };
};

export const editProject = (projectId, params) => {
  const {
    name,
    image,
    address,
    building_type_id,
    owner,
    designer,
    issuer,
    car_park_area,
    roof_top_area,
    other_area_with_roof,
    height,
    building_cost,
    latitude,
    longitude,
    province_id,
    description,
    evaluation_purpose,
  } = params;

  const formData = new FormData();
  if (name) formData.set('name', name);
  if (image) formData.set('image', image);
  if (address) formData.set('address', address);
  if (building_type_id) formData.set('building_type_id', building_type_id);
  if (owner) formData.set('owner', owner);
  if (designer) formData.set('designer', designer);
  if (issuer) formData.set('issuer', issuer);
  if (car_park_area) formData.set('car_parking_area', car_park_area);
  if (roof_top_area) formData.set('roof_top_area', roof_top_area);
  if (other_area_with_roof) formData.set('other_area_with_roof', other_area_with_roof);
  if (height) formData.set('height', height);
  if (building_cost) formData.set('building_cost', building_cost);
  if (latitude) formData.set('latitude', latitude);
  if (longitude) formData.set('longitude', longitude);
  if (province_id) formData.set('province_id', province_id);
  if (typeof(description) === 'string') formData.set('description', description);
  if (typeof(evaluation_purpose) === 'string') formData.set('evaluation_purpose', evaluation_purpose);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT}${projectId}/`,
      data: formData,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const uploadImage = (image, projectId) => {
  const formData = new FormData();
  if (projectId) formData.set('project_id', projectId);
  if (image) formData.set('image', image, `project_img_${new Date().valueOf()}`);
  return {
    type: ACTION.UPLOAD_IMAGE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_IMG}`,
      data: formData
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteImage = (imgId, projectId) => {
  return {
    type: ACTION.REMOVE_IMAGE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_IMG}${imgId}/`,
    })
      .then(() => ({ id: imgId, project_id:  projectId}))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteProject = (projectId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT}${projectId}/`,
      data: params,
    })
      .then(() => ({ id: projectId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const exportReport = (projectId) => {
  return {
    type: ACTION.EXPORT_REPORT,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT}${projectId}/rml/`,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorProject = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const createBuilding = params => {
  const {
    name,
    image,
    building_type_id,
    description,
    project_id,
  } = params;

  const formData = new FormData();
  formData.set('name', name);
  if (image) formData.set('image', image);
  formData.set('building_type_id', building_type_id);
  formData.set('description', description || '');
  formData.set('project_id', project_id);

  return {
    type: ACTION.CREATE_BUILDING,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_BUILDING,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editBuilding = (buildingId, params) => {
  const {
    name,
    image,
    building_type_id,
    description,
  } = params;

  const formData = new FormData();
  if (name) formData.set('name', name);
  if (image) formData.set('image', image);
  if (building_type_id) formData.set('building_type_id', building_type_id);
  if (typeof(description) === 'string') formData.set('description', description);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_BUILDING}${buildingId}/`,
      data: formData,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteBuilding = (buildingId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_BUILDING}${buildingId}/`,
      data: params,
    })
      .then(() => ({id: buildingId}))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const htmlToDoc = (title, body) => {
  return `<html xmlns:o='urn:schemas-microsoft-com:office:office'
                xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
            ${title}
            ${body}
          </html>`;
};

export const body = body => `<body>${body}</body>`;

export const title = title => `<head><meta charset='utf-8'><title>${title}</title></head>`;

export const exportSummaryReport = projectId => {
  return {
    type: ACTION.EXPORT_SUMMARY_REPORT,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_PROJECT}${projectId}/report/`,
    })
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/projects_actions.js